import { Post } from '../helpers';

const AttachGreenroomMask = async (meetingId: number, maskId: number, email: string): Promise<string> => {
  return Post({
    host: import.meta.env.VITE_GREENROOM_APP_SYNC_HOST,
    url: `/v1/room/${meetingId}/profile-masks/mutate`,
    body: {
      maskId: maskId,
      email: email,
      detach: false,
    },
    includeIdToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default AttachGreenroomMask;
